import { Theme } from '@emotion/react';
import { dark, deep, future, sketchy, system, tosh } from '@theme-ui/presets';

export const ThemePresets = {
  dark: { value: 'dark', theme: dark },
  deep: { value: 'deep', theme: deep },
  future: { value: 'future', theme: future },
  sketchy: { value: 'sketchy', theme: sketchy },
  system: { value: 'system', theme: system },
  tosh: { value: 'tosh', theme: tosh },
} as const;

export const Appearance = {
  light: 'light',
  dark: 'dark',
} as const;

export type ThemeValue =
  (typeof ThemePresets)[keyof typeof ThemePresets]['value'];
export type AppearanceValue = (typeof Appearance)[keyof typeof Appearance];

const makeTheme = <T extends Theme>(t: T): T => t;

export const myTheme = makeTheme({
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  colors: {
    highlight: 'transparent',
    modes: {
      dark: {
        highlight: 'transparent',
      },
    },
  },
  buttons: {
    primary: {
      border: '1px solid',
      borderColor: 'primary',
      cursor: 'pointer',
      color: 'background',
      backgroundColor: 'primary',
      fontFamily: 'body',
      fontWeight: 'body',
      '&:hover': {
        backgroundColor: 'transparent',
        color: 'primary',
      },
      '&:active': {
        backgroundColor: 'transparent',
        borderColor: 'primary',
        color: 'text',
      },
      '&:disabled': {
        backgroundColor: 'muted',
        cursor: 'default',
        pointerEvents: 'none',
        borderColor: 'gray',
        color: 'gray',
      },
    },
  },
  forms: {
    label: {
      fontSize: 1,
      fontFamily: 'body',
      fontWeight: 'body',
      cursor: 'pointer',
      width: 'auto',
    },
    input: {
      transition: 'border-color .2s ease-out',
      borderColor: 'gray',
      outline: 'none',
      fontFamily: 'body',
      fontWeight: 'body',
      '&:focus': {
        borderColor: 'primary',
      },
    },
    select: {
      cursor: 'pointer',
      transition: 'border-color .2s ease-out',
      borderColor: 'gray',
      fontFamily: 'body',
      fontWeight: 'body',
      '&:focus': {
        borderColor: 'primary',
        outline: 'none',
      },
    },
    textarea: {
      cursor: 'pointer',
      transition: 'border-color .2s ease-out',
      borderColor: 'gray',
      fontFamily: 'body',
      fontWeight: 'body',
      '&:focus': {
        borderColor: 'primary',
        outline: 'none',
      },
    },
    slider: {
      bg: 'muted',
    },
    checkbox: {
      transition: 'border-color .2s ease-out',
      cursor: 'pointer',
    },
  },
});
